import { createSlice } from "@reduxjs/toolkit";
import { startExamActivity } from "../../activityAsyncAction";
import { login } from "../authVerification/authThunk";
import { submitExam } from "../../activityAsyncAction";

const initialState = {
  deductionTime: 0,
  examStarted: false,
  examEnded: false,
  cam1Start: false,
  cam2Start: false,
  submitShow: false,
  faceAPIloaded: false,
  counterIntervalId: null,
  randomize: null,
  timeCount: 0,
  times: {
    startTime: null,
    expiryTime: null,
  },
};

export const timerSlice = createSlice({
  name: "timer",
  initialState,
  reducers: {
    updateEnd: (state) => {
      //Ending the exam
      let { examEnded } = state;
      if (!examEnded) {
        console.log("update start is fired");
        state.examEnded = !examEnded;
      }
    },
    deductTime: (state) => {
      console.log("expiry before", state.times.expiryTime);
      state.times.expiryTime = state.times.expiryTime - state.deductionTime;
      console.log("expiry after", state.times.expiryTime);
    },
    countDown: (state) => {
      state.timeCount++;
    },
    setCounterIntervalId: (state, action) => {
      state.counterIntervalId = action.payload;
    },
    fetchTimerDetails: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
    },
    handleSubmitModalChange: (state) => {
      state.submitShow = !state.submitShow;
    },
    setCam1Start: (state, action) => {
      state.cam1Start = action.payload;
    },
    setCam2Start: (state, action) => {
      state.cam2Start = action.payload;
    },
    setFaceAPI: (state, action) => {
      state.faceAPIloaded = action.payload;
    },
    setRandomize: (state, action) => {
      state.randomize = action.payload;
    },
  },
  extraReducers: {
    [startExamActivity.fulfilled]: (state, action) => {
      //starts the exam when the activity is started
      const { data } = action.payload;
      let { examStarted } = state;
      if (!examStarted) {
        console.log("update start is fired");
        state.examStarted = !examStarted;
        state.times.startTime = Date.now();
        state.times.expiryTime = data.examActivity.duration;
      }
    },
    [login.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.times.expiryTime = data?.exam?.duration ?? state.times.expiryTime;
      state.deductionTime =
        (data?.exam?.punishment?.deductTime?.timeInMinutes ?? 0) * 60 * 1000;
    },
    [submitExam.fulfilled]: (state) => {
      state.examEnded = true;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  updateEnd,
  deductTime,
  setCam1Start,
  setCam2Start,
  handleSubmitModalChange,
  setFaceAPI,
  setCounterIntervalId,
  setRandomize,
  countDown,
} = timerSlice.actions;

export default timerSlice.reducer;
